







































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class IconLauncher extends Vue {
  @Prop({ default: false }) light!: boolean;
  @Prop({ default: false }) dark!: boolean;
  @Prop({ default: false }) attensi!: boolean;

  darkColor = '#252B3A';
  lightColor = '#ffffff';
  iconColor = '#56BDD0';


  getTextColor() {
    if (this.dark) { return this.darkColor; }
    if (this.light) { return this.lightColor; }
    if (this.attensi) { return this.iconColor; }
    return this.darkColor;
  }

}
